import { object, string } from "yup";

export const VALIDATION_SCHEMA = object({
  text: string().required("Comment can’t be blank.")
});

export const SCROLLBAR_STYLES = {
  "&::-webkit-scrollbar": {
    width: "12px",
    border: "none"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "gray.400",
    borderRadius: "24px",
    border: "2px solid white"
  }
};
